<template>
  <div>
    <template v-if="isLoading">
      <div class="skeleton-wrapper">
        <div
          v-for="n in lines"
          :key="n"
          class="skeleton skeleton-text"
          :style="getSkeletonLineStyle(n)"
        ></div>
      </div>
    </template>

    <template v-else-if="isError">
      <div class="d-flex" style="gap: 8px; flex-wrap: wrap;">
        <p class="text-danger mb-2">{{ errorMessage }}</p>
        <b-button size="sm" variant="outline-danger" @click="$emit('retry')">
          Coba Lagi
        </b-button>
      </div>
    </template>

    <template v-else>
      <slot />
    </template>
  </div>
</template>

<script>
export default {
    name: "StateDetailHandler",
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        isError: {
            type: Boolean,
            default: false,
        },
        errorMessage: {
            type: String,
            default: "Gagal memuat data.",
        },
        lines: {
            type: Number,
            default: 3,
        },
    },
    methods: {
        getSkeletonLineStyle(lineNumber) {
            if (this.lines > 1 && lineNumber === this.lines) {
                return { width: '60%' };
            }
            return { width: '100%' };
        },
    }
};
</script>

<style scoped>
.skeleton-text {
    height: 16px;
    margin-bottom: 10px;
}
.skeleton-text:last-child {
    margin-bottom: 0;
}
</style>